import { restResourceRequester } from "../rest-resource-requester";
import { stringify } from "../../util/querystring-util";
import { GetPartnersRequest } from "./get-partners/GetPartnersRequest";
import { GetPartnersResponse } from "./get-partners/GetPartnersResponse";
import { UpdatePartnersDeletionFlagsRequest } from "./update-partners-deletion-flags/UpdatePartnersDeletionFlagsRequest";
import { UpdatePartnersDeletionFlagsResponse } from "./update-partners-deletion-flags/UpdatePartnersDeletionFlagsResponse";

interface PartnersRestResource {
  getPartners(request: GetPartnersRequest): Promise<GetPartnersResponse>;
  updatePartnersDeletionFlags(
    request: UpdatePartnersDeletionFlagsRequest,
  ): Promise<UpdatePartnersDeletionFlagsResponse>;
}

/**
 * GET /partners
 */
const getPartners = restResourceRequester<
  GetPartnersRequest,
  GetPartnersResponse
>("GET", (request) => {
  const queryParameters = {
    dipByRgn: request.dipByRgn,
    cpntId: request.cpntId,
    ptnrCd: request.ptnrCd,
    ptnrName: request.ptnrName,
  };
  return `/partners?${stringify(queryParameters)}`;
});

/**
 * PUT /partner/deletionFlags
 */
const updatePartnersDeletionFlags = restResourceRequester<
  UpdatePartnersDeletionFlagsRequest,
  UpdatePartnersDeletionFlagsResponse
>(
  "PUT",
  (_) => `/partners/deletionFlags`,
  (request) => JSON.stringify(request),
);

export const PartnersRestResource: PartnersRestResource = {
  getPartners: getPartners,
  updatePartnersDeletionFlags: updatePartnersDeletionFlags,
};
